var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "vector",
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 469.333 469.333",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M234.667,149.333c-47.147,0 -85.333,38.187 -85.333,85.333S187.52,320 234.667,320S320,281.813 320,234.667S281.813,149.333 234.667,149.333zM425.387,213.333C415.573,124.373 344.96,53.76 256,43.947V0h-42.667v43.947C124.373,53.76 53.76,124.373 43.947,213.333H0V256h43.947c9.813,88.96 80.427,159.573 169.387,169.387v43.947H256v-43.947C344.96,415.573 415.573,344.96 425.387,256h43.947v-42.667H425.387L425.387,213.333zM234.667,384c-82.453,0 -149.333,-66.88 -149.333,-149.333s66.88,-149.333 149.333,-149.333S384,152.213 384,234.667S317.12,384 234.667,384z",
    id: "path_0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.2e937c33d9d5943de64b05288532f792.svg";
export { ForwardRef as ReactComponent };